import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateSearchState from './search';
import updateSearchSharingState from '../sharing/state/searchSharing';

const handlers = {
  ...updateSearchState,
  ...updateSearchSharingState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
